import '@/common';
import { createCatalogToolbarWidget } from '@/widgets/CatalogToolbarWidget';
import { createSmartFilterWidget } from '@/widgets/SmartFilterWidget';

createSmartFilterWidget(document.querySelector('#smart-filter-widget')!);
createCatalogToolbarWidget(document.querySelector('#toolbar-widget')!);
